import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/**注意：路由的path和redirect一定要写成全路径，这样子方便对后台配置的路由进行是否有效验证**/
import Layout from '@/views/layout'
import Mould from '@/views/mould'
import aboutSr from '@/views/aboutSr'
import joinUs from '@/views/joinUs'
export const constantRouterMap = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'Index',
        meta: { title: '首页' },
        component: () => import('@/views/index')
      }
    ]
  },
  {
    path: '/mould',
    component: Layout,
    redirect: '/mould/aboutSr',
    children: [
      // 关于森锐新闻相关的路由
      {
        path: '/mould/aboutSr',
        name: 'AboutSr',
        component: Mould,
        redirect: '/mould/aboutSr/news',
        children: [
          {
            path: '/mould/aboutSr/news',
            name: 'News',
            component: aboutSr,
            redirect: '/mould/aboutSr/news/newsList',
            children: [
              {
                path: '/mould/aboutSr/news/newsList',
                name: 'NewsList',
                meta: { title: '森锐动态', titleIsShow: true },
                component: () => import('@/views/aboutSr/page/list')
              },
              {
                path: '/mould/aboutSr/news/newsDetails',
                name: 'NewsDetails',
                meta: { title: '详情', titleIsShow: true },
                component: () => import('@/views/aboutSr/page/details'),
              }
            ]
          }
        ]
      },
      // 产品方面相关路由
      {
        path: '/mould/products',
        name: 'Products',
        meta: { title: '产品', titleIsShow: true },
        component: Mould,
        redirect: '/mould/products/productsDetail',
        children: [
          {
            path: '/mould/products/productsDetail',
            name: 'ProductsDetail',
            meta: { title: '产品详情' },
            component: () => import('@/views/products')
          },
          {
            path: '/mould/products/productsList',
            name: 'productsList',
            meta: { title: '产品列表', titleIsShow: true },
            component: () => import('@/views/products/productsList')
          }
        ]
      },
      // 解决方案相关路由
      {
        path: '/mould/solution',
        name: 'Solution',
        meta: { title: '解决方案', titleIsShow: true },
        component: Mould,
        redirect: '/mould/solution/solutionDetail',
        children: [
          {
            path: '/mould/solution/solutionDetail',
            name: 'solutionDetail',
            meta: { title: '解决方案详情' },
            component: () => import('@/views/solution')
          }
        ]
      },
      // 支持与服务相关路由
      {
        path: '/mould/support',
        name: 'Support',
        component: Mould,
        redirect: '/mould/support/deviceList',
        children: [
          {
            path: '/mould/support/deviceList',
            name: 'DeviceList',
            meta: { title: '支持与服务', titleIsShow: true },
            component: () => import('@/views/support/deviceList'),
          },
          {
            path: '/mould/support/deviceDetails',
            name: 'DeviceDetails',
            meta: { title: '更多', titleIsShow: true },
            component: () => import('@/views/support/deviceDetails'),
          }
        ]
      },
      // 关于加入我们的路由
      {
        path: '/mould/joinUs',
        name: 'JoinUs',
        component: Mould,
        redirect: '/mould/joinUs/info',
        children: [
          {
            path: '/mould/joinUs/info',
            name: 'Info',
            component: joinUs,
            redirect: '/mould/joinUs/info/infoList',
            children: [
              {
                path: '/mould/joinUs/info/infoList',
                name: 'InfoList',
                meta: { title: '加入森锐', titleIsShow: true },
                component: () => import('@/views/joinUs/page/list')
              },
              {
                path: '/mould/joinUs/info/infoDetails',
                name: 'InfoDetails',
                meta: { title: '详情', titleIsShow: true },
                component: () => import('@/views/joinUs/page/details'),
              }
            ]
          }
        ]
      },
    ]
  },
  {
    path: '/pageCustomi',
    component: Layout,
    redirect: '/pageCustomi/pageCustomiDetail',
    children: [
      {
        path: '/pageCustomi/pageCustomiDetail',
        name: 'PageCustomiDetail',
        component: () => import('@/views/pageCustomi')
      }
    ]
  }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js